export const dateComparisonOperators = ["before", "after"] as const;

export type DateComparisonOperator = (typeof dateComparisonOperators)[number];

export const dateComparisonToLabel: Record<DateComparisonOperator, string> = {
  before: "before",
  after: "after",
};
